// extracted by mini-css-extract-plugin
export default {"pacContainer":"GroupPacView_pacContainer__nRSMu","newPacButton":"GroupPacView_newPacButton__BfESY","pacsList":"GroupPacView_pacsList__kC4hA"};